var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.0058 1.65337C5.06515 0.594024 6.50193 -0.00111389 8.00008 -0.00111389C9.49823 -0.00111389 10.935 0.594023 11.9944 1.65337C13.0537 2.71272 13.6489 4.14951 13.6489 5.64766V10.6912C13.6489 11.0446 13.7892 11.3836 14.0392 11.6335C14.3227 11.917 14.5456 12.0238 14.8572 12.0238C15.1728 12.0238 15.4287 12.2795 15.4287 12.5952C15.4287 12.9107 15.1728 13.1666 14.8572 13.1666H1.14296C0.827371 13.1666 0.571533 12.9107 0.571533 12.5952C0.571533 12.2795 0.827371 12.0238 1.14296 12.0238C1.45462 12.0238 1.67743 11.917 1.96101 11.6335C2.21092 11.3836 2.3513 11.0446 2.3513 10.6912V5.64766C2.3513 4.14951 2.94645 2.71272 4.0058 1.65337ZM6.0001 15.1429C6.0001 14.6695 6.38386 14.2857 6.85725 14.2857H9.14296C9.61635 14.2857 10.0001 14.6695 10.0001 15.1429C10.0001 15.6162 9.61635 16 9.14296 16H6.85725C6.38386 16 6.0001 15.6162 6.0001 15.1429Z",
    fill: "#6D6584"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.b255d8bc1a5da57eec33aadbf944c159.svg";
export { ForwardRef as ReactComponent };